import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Gran Turismo 7",
    maxPrice: "6000",
    price: "5000",
    platform: "PlayStation",
    genre: "Sports",
    brand: "EA",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 1,
  },
  {
    _id: uuid(),
    title: "Horizon Forbidden West - Special Edition",
    maxPrice: "6000",
    price: "700",
    platform: "PlayStation",
    genre: "Sports",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 2,
  },
  {
    _id: uuid(),
    title: "Horizon Forbidden West",
    maxPrice: "6000",
    price: "1200",
    platform: "PlayStation",
    genre: "Sports",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 3,
  },
  {
    _id: uuid(),
    title: "Bloodborne",
    maxPrice: "6000",
    price: "1800",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "Sony",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 4,
  },
  {
    _id: uuid(),
    title: "The Last Of Us Remastered",
    maxPrice: "6000",
    price: "3500",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "Tencent",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 5,
  },
  {
    _id: uuid(),
    title: "Days Gone",
    maxPrice: "6000",
    price: "4200",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "Tencent",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 1,
  },
  {
    _id: uuid(),
    title: "Nioh",
    maxPrice: "6000",
    price: "3200",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "Sony",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 2,
  },
  {
    _id: uuid(),
    title: "Gran Turismo Sport",
    maxPrice: "6000",
    price: "2800",
    platform: "PlayStation",
    genre: "Sports",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 3,
  },
  {
    _id: uuid(),
    title: "The Last of Us Part II Standard Edition",
    maxPrice: "6000",
    price: "3800",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "EA",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 4,
  },
  {
    _id: uuid(),
    title: "The Last Of Us Remastered",
    maxPrice: "6000",
    price: "1400",
    platform: "PlayStation",
    genre: "Role-playing",
    brand: "EA",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 5,
  },
  {
    _id: uuid(),
    title: "Detroit: Become Human",
    maxPrice: "6000",
    price: "1950",
    platform: "PlayStation",
    genre: "Shooter",
    brand: "Sony",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 1,
  },
  {
    _id: uuid(),
    title: "Uncharted: The Lost Legacy",
    maxPrice: "6000",
    price: "2250",
    platform: "PlayStation",
    genre: "Shooter",
    brand: "Sony",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 2,
  },
  {
    _id: uuid(),
    title: "Gears 5",
    maxPrice: "6000",
    price: "4200",
    platform: "Xbox",
    genre: "Shooter",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 3,
  },
  {
    _id: uuid(),
    title: "Forza Horizon 4",
    maxPrice: "6000",
    price: "900",
    platform: "Xbox",
    genre: "Shooter",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 4,
  },
  {
    _id: uuid(),
    title: "Crackdown 3",
    maxPrice: "6000",
    price: "1200",
    platform: "Xbox",
    genre: "Shooter",
    brand: "Tencent",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 5,
  },
  {
    _id: uuid(),
    title: "State of Decay 2",
    maxPrice: "6000",
    price: "1800",
    platform: "Xbox",
    genre: "Shooter",
    brand: "Tencent",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 1,
  },
  {
    _id: uuid(),
    title: "Gran Turismo 7",
    maxPrice: "6000",
    price: "1800",
    platform: "Xbox",
    genre: "Shooter",
    brand: "Sony",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 2,
  },
  {
    _id: uuid(),
    title: "Bleeding Edge",
    maxPrice: "6000",
    price: "1300",
    platform: "Xbox",
    genre: "Shooter",
    brand: "EA",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 3,
  },
  {
    _id: uuid(),
    title: "Triangle Strategy",
    maxPrice: "6000",
    price: "3300",
    platform: "Nintendo",
    genre: "Real-time strategy",
    brand: "Nintendo",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 4,
  },
  {
    _id: uuid(),
    title: "Monopoly",
    maxPrice: "6000",
    price: "600",
    platform: "Nintendo",
    genre: "Real-time strategy",
    brand: "Nintendo",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 5,
  },
  {
    _id: uuid(),
    title: "Super Smash Bros. Ultimate",
    maxPrice: "6000",
    price: "2800",
    platform: "Nintendo",
    genre: "Real-time strategy",
    brand: "Nintendo",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 1,
  },
  {
    _id: uuid(),
    title: "Mario & Rabbids Kingdom Battle",
    maxPrice: "6000",
    price: "3400",
    platform: "Nintendo",
    genre: "Real-time strategy",
    brand: "Nintendo",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 2,
  },
  {
    _id: uuid(),
    title: "Football Manager 2022",
    maxPrice: "6000",
    price: "3200",
    platform: "PC Gaming",
    genre: "Real-time strategy",
    brand: "EA",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 3,
  },
  {
    _id: uuid(),
    title: "Farming Simulator 22 Collector's Edition",
    maxPrice: "6000",
    price: "5000",
    platform: "PC Gaming",
    genre: "Real-time strategy",
    brand: "Tencent",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 4,
  },
  {
    _id: uuid(),
    title: "Classic Monopoly",
    maxPrice: "6000",
    price: "700",
    platform: "Board Games",
    genre: "Real-time strategy",
    brand: "Microsoft",
    image:
      "https://cdn.game.net/image/upload/w_750,f_auto,q_auto/v1/game_img/merch2021/Games/StrangersOfParadise/StrangersOfParadise-E.jpg",
    ratings: 5,
  },
];
